export enum TextMatchMode {
  Equals = 0,
  StartsWith = 1,
  Contains = 2,
  DoesNotContain = 3
}

export enum ListingType {
  Primary = 0,
  Secondary = 1,
  All = 2
}

export interface TextCriterion {
  mode: TextMatchMode;
  value: string;
}

export interface CustomerCompaniesSearchRequest {
  companyName?: TextCriterion | null;
  stockSymbol?: TextCriterion | null;
  countryIds: string[];
  listingType?: ListingType | null;
  industryIds: string[];
  superSectorIds: string[];
  sectorIds: string[];
  subSectorIds: string[];
  stockExchangeIds: string[];
  stockIndexIds: string[];
  yearFrom?: number | null;
  yearTo?: number | null;
  pageNumber: number;
  pageSize: number;
  sortBy?: string;
  ascending?: boolean;
}
